import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ChatService } from './services/chat.service';
import { takeUntil } from 'rxjs/operators';
import { Logger } from '@app/core/logging';
import { Persist } from '@app/analytics/actions/data-layer';
import { Subject } from 'rxjs';
import { Store } from '@ngrx/store';
import { IAppState } from '@app/store';

@Component({
  selector: 'vc-chat-page',
  templateUrl: './chat-page.component.html',
  styleUrls: ['./chat-page.component.scss']
})
export class ChatPageComponent implements OnInit, AfterViewInit, OnDestroy {
  selectedChannelId: string;
  private ngUnsubscribe = new Subject<void>();

  constructor(
    private route: ActivatedRoute,
    private chatService: ChatService,
    private logger: Logger,
    private store: Store<IAppState>
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe({
      next: params => (this.selectedChannelId = params['id'])
    });

    this.chatService.init();
  }

  ngAfterViewInit() {
    this.route.data.pipe(takeUntil(this.ngUnsubscribe)).subscribe(data => {
      if (data.pageAnalytics) {
        this.store.dispatch(new Persist(data.pageAnalytics));
      }
    }, this.logger.error);
  }

  ngOnDestroy() {
    this.ngUnsubscribe.complete();
  }

  onSelectChannelId(event: string) {
    this.selectedChannelId = event;
  }
}
